import {
  motion,
  useScroll,
  useTransform,
  useMotionValueEvent,
  AnimatePresence,
  useSpring,
} from "framer-motion";
import { useRef } from "react";
import { RandomBubbles } from "./random-bubbles/random-bubbles";
import ReactMarkdown from "react-markdown";
import { BubbleAnimation } from "../../components/bubble";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaArrowDown,
} from "react-icons/fa";
import Round from "../../Round.svg";
import {
  useSectionVisibility,
  useScrollContext,
} from "../../utils/ScrollContext";
import { ANIMATION_TIMING, EASING_CURVES } from "../../utils/motion";

import { useEffect } from "react";

export const SAMLogo = ({ textes, hideScroll, setIsBackgroundWhite }) => {
  const targetRef = useRef(null);
  const { ref: sectionRef } = useSectionVisibility("sam-logo", 0.3);
  const { getVisibleSections } = useScrollContext();
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"],
  });
  const smoothScrollYProgress = useSpring(scrollYProgress, { stiffness: 100, damping: 30 });
  const backgroundOpacity = useTransform(
    smoothScrollYProgress,
    [0.15, 0.2, 0.3, 0.5, 1],
    [0, 0.8, 0.8, 0.9, 1]
  );
  const backgroundRotation = useTransform(smoothScrollYProgress, [0, 1], [0, 360]);

  const finalTextOpacity = useTransform(
    smoothScrollYProgress,
    [0.15, 0.22, 0.50, 0.50],
    [0, 0.5, 1, 1]
  );
  const stayConnectedOpacity = useTransform(
    smoothScrollYProgress,
    [0.15, 0.22, 0.50, 0.50],
    [0, 0, 0, 1]
  );

  const emailOpacity = useTransform(
    smoothScrollYProgress,
    [0.15, 0.22, 0.50, 0.6],
    [0, 0, 0, 1]
  );

  const span1PosX = useTransform(
    smoothScrollYProgress,
    [0.10, 0.15, 0.20, 0.25],
    ["-100%", "-66%", "-33%", "0%"]
  );
  const span1PosY = useTransform(
    smoothScrollYProgress,
    [0.10, 0.15, 0.20, 0.25],
    ["-100%", "-66%", "-33%", "0%"]
  );
  const span1TextSize = useTransform(
    smoothScrollYProgress,
    [0.10, 0.15, 0.20, 0.25],
    ["30vw", "25vw", "20vw", "15vh"]
  );

  const span2PosX = useTransform(
    smoothScrollYProgress,
    [0.25, 0.30, 0.35, 0.40],
    ["-100%", "-66%", "-33%", "0%"]
  );
  const span2PosY = useTransform(
    smoothScrollYProgress,
    [0.25, 0.30, 0.35, 0.40],
    ["-200%", "-66%", "-33%", "0%"]
  );
  const span2TextSize = useTransform(
    smoothScrollYProgress,
    [0.25, 0.30, 0.35, 0.40],
    ["30vw", "25vw", "20vw", "15vh"]
  );

  const span3PosX = useTransform(
    smoothScrollYProgress,
    [0.4, 0.5, 0.55, 0.6],
    ["200%", "175%", "150%", "0%"]
  );
  
   const span3PosY = useTransform(
     smoothScrollYProgress,
     [0.4, 0.5, 0.55, 0.6],
     ["-200%", "-66%", "-33%", "0%"]
   );
   const span3TextSize = useTransform(
     smoothScrollYProgress,
     [0.4, 0.5, 0.55, 0.6],
     ["30vw", "25vw", "20vw", "15vh"]
   );

  const stayConnectedX = useTransform(
    smoothScrollYProgress,
    [0.15, 0.22, 0.3, 0.45],
    ["30%", "30%", "30%", "0%"]
  );
  const stayConnectedY = useTransform(
    smoothScrollYProgress,
    [0.35, 0.40, 0.45, 0.50],
    ["700%", "375%", "375%", "320%"]
  );

  const contactX = useTransform(
    smoothScrollYProgress,
    [0.35, 0.40, 0.45, 0.50],
    ["60%", "60%", "60%", "0%"]
  );

  const contactY = useTransform(
    smoothScrollYProgress,
    [0.35, 0.40, 0.45, 0.50],
    ["350%", "450%", "450%", "300%"]
  );

  useMotionValueEvent(smoothScrollYProgress, "change", (value) => {
    if (value > 0.3) {
      setBgWhite(false);
      if (hideScroll) {
        hideScroll(true);
      }
    } else if (value < 0.3) {
      setBgWhite(true);
    } else if (value < 0.8) {
      if (hideScroll) hideScroll(false);
    }
  });

  const setBgWhite = (value) => {
    const visibleSections = getVisibleSections();
    if (visibleSections.includes("sam-logo")) {
      setIsBackgroundWhite(value);
    }
  };

  return (
    <>
      <motion.section
        id="contact"
        ref={targetRef}
        className="flex items-center justify-start h-[150vh]"
      >
        <div
          ref={sectionRef}
          className=" top-[20%] sticky whitespace-nowrap before:absolute pb-[60vh] my-auto mx-auto w-full"
        >
          <motion.div
            style={{
              opacity: backgroundOpacity,
              rotate: backgroundRotation,
              backgroundImage: `url(${Round})`,
            }}
            className="absolute inset-0 bg-contain bg-no-repeat bg-center h-[400px] w-[400pxvw] z-0 mx-auto pb-[15rem] "
          />
          <div className='flex mx-auto absolute inset-0 z-10 w-[100%] items-center justify-center mt-[5vh]'>
          <motion.span
            style={{
              opacity: finalTextOpacity,
              x: span1PosX,
              y: span1PosY,
              fontFamily: "SAM",
              color: "white",
              fontSize: span1TextSize,
            }}
            className="font-sam text-white mb-auto "
          >
            S
          </motion.span>
          <motion.span
            style={{
              opacity: finalTextOpacity,
              x: span2PosX,
              y: span2PosY,
              fontFamily: "SAM",
              color: "white",
              fontSize: span2TextSize,
            }}
            className="font-sam text-white mb-auto "
          >
            A
          </motion.span>
          <motion.span
            style={{
              opacity: finalTextOpacity,
              x: span3PosX,
              y: span3PosY,
              fontFamily: "SAM",
              color: "white",
              fontSize: span3TextSize,
            }}
            className="font-sam text-white mb-auto "
          >
            M
          </motion.span>
        </div>
          <div className='flex  justify-center '>

          <motion.span
            style={{
              opacity: stayConnectedOpacity,
              alignContent: "center",
              alignSelf: "center",
              display: "flex",
              x: stayConnectedX,
              y: stayConnectedY,
              color: "white",
              fontFamily: "Lexend",
            }}
            // className="absolute"
          >
            <ReactMarkdown
              className="text-white text-7xl text-center mt-14"
              escapeHtml={false}
              components={{
                strong: ({ node, ...props }) => (
                  <span className="text-[#00ffcc] font-sam font-[200]" {...props} />
                ),
              }}
            >
              {textes?.stayConnected.replace("\n", `\n`)}
            </ReactMarkdown>
          </motion.span>
          <motion.a
            className="absolute border-[#00FFCC] border-2 rounded-full p-10 bottom-[40%]"
            href={"mailto:" + textes?.contactEmail.replace(/\*\*/g, "")}
            whileHover={{
              scale: 1.3,
              transition: { duration: 0.2, ease: "easeIn", type: "spring" },
            }}
            style={{
              opacity: emailOpacity,
              alignContent: "center",
              alignSelf: "center",
              display: "flex",
              x: contactX,
              y: contactY,
              color: "white",
              fontFamily: "Lexend",
            }}
          >
            <BubbleAnimation>
              <ReactMarkdown
                className="text-white text-5xl"
                escapeHtml={false}
                style={{
                  fontFamily: "Lexend !important",
                }}
                components={{
                  strong: ({ node, ...props }) => (
                    <span className="text-[#00ffcc] font-sam font-[200]" {...props} />
                  ),
                }}
              >
                {textes?.contactEmail}
              </ReactMarkdown>
            </BubbleAnimation>
          </motion.a>
        </div>

        </div>
      </motion.section>
      <div
        id="footer"
        className="flex flex-row items-center max-w-[1440px] mx-auto my-10"
      >
          <motion.span
          className="w-1/3 text-right mb-10"
          style={{
            fontFamily: "Lexend",
          }}
        > </motion.span>
        <motion.div
          className="w-1/3 text-center text-white inline-flex justify-center items-center mx-auto"
          style={{
            fontFamily: "Lexend",
          }}
        >
          <motion.a
            className="text-5xl mx-2 flex"
            href={textes?.facebookLink}
            target="_blank"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaFacebookF />
          </motion.a>

          <motion.a
            className="text-5xl mx-2 flex"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            href={textes?.instagramLink}
            target="_blank"
          >
            <FaInstagram />
          </motion.a>
          <motion.a
            className="text-5xl mx-2 flex"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            href={textes?.linkedinLink}
            target="_blank"
          >
            <FaLinkedin />
          </motion.a>
        </motion.div>
        <motion.span
          className="flex-1 text-right"
          style={{
            fontFamily: "Lexend",
          }}
        >
          <ReactMarkdown
            className="text-white text-3xl"
            escapeHtml={false}
            components={{
              strong: ({ node, ...props }) => (
                <span className="text-[#00ffcc] font-sam font-[200]" {...props} />
              ),
            }}
            style={{
              fontFamily: "Lexend",
            }}
          >
            {textes?.allRightsReserved + new Date().getFullYear()}
          </ReactMarkdown>
        </motion.span>
      </div>
    </>
  );
};

export default SAMLogo;

